import { OptionsObject, SnackbarKey, SnackbarMessage, useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import useDebugInformation from '../../../hooks/useDebugInformation';
import { ui } from '../../../interfaces/interfaces';
import { useAppSelector } from "@store/hooks";

const name = "SnackBarMini"

type Props = {
    parent: string
}

const SnackBarMini: React.FC<Props> = ({ parent }) => {
    const problemShowMsg = useAppSelector(({ ui }) => ui.ProblemShowMsg)
    const problemMsg = useAppSelector(({ ui }) => ui.ProblemMsg)
    const problemMsgVariant = useAppSelector(({ ui }) => ui.ProblemMsgVariant)

    const showSnackBar = React.useCallback((enqueueSnackbar: {
        (message: SnackbarMessage, options?: OptionsObject | undefined): SnackbarKey; (arg0: any, arg1: { variant: any; }): any;
    }) => {
        enqueueSnackbar(problemMsg, { variant: problemMsgVariant });
        ui.ProblemShowMsg = false;
    }, [problemMsg, problemMsgVariant])

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        problemShowMsg && showSnackBar(enqueueSnackbar)
    }, [enqueueSnackbar, problemShowMsg, showSnackBar])

    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { problemMsg, problemMsgVariant, problemShowMsg })

    return (
        <div>   </div>
    );
}

export default React.memo(SnackBarMini)
